<template>
  <v-container fluid>
      <v-layout row wrap>
        <v-btn flat @click.native="goBack"><v-icon left>keyboard_backspace</v-icon>Вернуться</v-btn>
      </v-layout>
      <ClinicItemNew />
  </v-container>
  </template>
  
  <script>
  import ClinicItemNew from '@/components/spravochnik/ClinicItemNew'
  
  export default {
    data() {
      return {}
    },
    computed: {},
    methods: {
      goBack() {
        return this.$router.go(-1)
      }
    },
    components: {
      ClinicItemNew
    }
  }
  </script>
  
  <style>
  .badge__badge {
    right: -60px;
  }
  </style>
  